import {
  formatDateTime,
  isPastDue,
  isoToLocalInput,
  localInputToIso,
  nowLocalInput,
} from '../../../shared/format/index.js';
import type { TaskPriority, TaskStatus } from '../api/tasks.client.js';
import { i18n } from '../../../i18n/index.js';
import type { EntityStatusTone } from '../../../components/entity-detail/EntityStatusChip.js';

// Реэкспорт общих хелперов: фичи уже импортируют их отсюда, а единственный
// источник теперь — shared/format.
export { formatDateTime, isPastDue, isoToLocalInput, localInputToIso, nowLocalInput };

export function getTaskStatusLabel(status: TaskStatus): string {
  return i18n.t(`crm.features.task.status.${status}`);
}

export function getTaskPriorityLabel(priority: TaskPriority): string {
  return i18n.t(`crm.features.task.priority.${priority}`);
}

export function getTaskStatusOptions(): Array<{ value: TaskStatus; label: string }> {
  return (['todo', 'in_progress', 'blocked', 'done', 'cancelled'] as const).map((value) => ({
    value,
    label: getTaskStatusLabel(value),
  }));
}

export function getTaskPriorityOptions(): Array<{ value: TaskPriority; label: string }> {
  return (['low', 'medium', 'high', 'urgent'] as const).map((value) => ({
    value,
    label: getTaskPriorityLabel(value),
  }));
}

// Shared semantic chip tones, independent of the preset palette.
export const STATUS_TONE: Record<TaskStatus, EntityStatusTone> = {
  todo: 'default',
  in_progress: 'processing',
  blocked: 'error',
  done: 'success',
  cancelled: 'default',
};

export const PRIORITY_TONE: Record<TaskPriority, EntityStatusTone> = {
  low: 'default',
  medium: 'default',
  high: 'warning',
  urgent: 'error',
};

// Логический порядок для сортировки колонок (не алфавитный).
export const STATUS_ORDER: Record<TaskStatus, number> = {
  todo: 0,
  in_progress: 1,
  blocked: 2,
  done: 3,
  cancelled: 4,
};

export const PRIORITY_ORDER: Record<TaskPriority, number> = {
  low: 0,
  medium: 1,
  high: 2,
  urgent: 3,
};

/**
 * Просрочка задачи: срок в прошлом и работа ещё не закрыта.
 * Выполненные и отменённые задачи просроченными не считаются.
 * (Общий предикат по дате — `isPastDue` из `shared/format`.)
 */
export function isOverdue(task: { dueAt?: string | null; status: TaskStatus }): boolean {
  if (task.status === 'done' || task.status === 'cancelled') return false;
  return isPastDue(task.dueAt);
}
